/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {ContactId} from "./contactId.zod";

export const CustomerSelection = zod.object({
  customerId: zod.uuid(),
  contactId: ContactId,
});

export type CustomerSelection = zod.input<typeof CustomerSelection>;
export type CustomerSelectionOutput = zod.output<typeof CustomerSelection>;
